import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { AibaLogo } from "../components/site/Logo";
import { ArrowLeft, ScrollText } from "lucide-react";

const SECTIONS = [
  {
    title: "1. Gestion des paiements et des fonds",
    body: [
      "La plateforme AIBA agit exclusivement comme un service de mise en relation technique permettant la vente de produits numériques.",
      "AIBA ne détient, ne conserve et ne manipule, à aucun moment, les fonds des utilisateurs ou des vendeurs. Tous les processus de transaction financière, de répartition des paiements, de gestion des commissions et de versement des gains sont traités de manière sécurisée et exclusive par notre partenaire de paiement tiers, Stripe (via le service Stripe Connect).",
      "En utilisant AIBA, vous reconnaissez que :",
    ],
    bullets: [
      "Tout montant affiché sur votre interface de suivi constitue une donnée informative reflétant les transactions traitées par Stripe.",
      "L'exécution, la conformité et le transfert effectif des fonds sont régis par les conditions d'utilisation de Stripe.",
      "AIBA ne propose aucun service de portefeuille électronique (wallet) ou de garde de fonds. Toute demande de retrait ou de transfert est traitée de manière automatisée par Stripe conformément à ses propres protocoles de sécurité et de conformité financière.",
    ],
  },
  {
    title: "2. Programme d'affiliation et commissions",
    body: [
      "Le programme d'ambassadeur ou d'affiliation d'AIBA constitue une opportunité de collaboration basée sur la performance. La participation à ce programme ne crée aucune relation de travail, de salariat ou de partenariat d'affaires entre le participant et AIBA.",
    ],
    bullets: [
      "Nature des gains : Les sommes versées aux ambassadeurs sont strictement des commissions calculées sur les ventes effectives générées par leur lien de recommandation unique, après déduction des frais de traitement bancaire de Stripe.",
      "Aucune garantie de revenu : AIBA ne garantit aucun niveau de revenu, de succès ou de vente. Les commissions ne sont dues que sur les transactions confirmées et non contestées par les clients finaux.",
      "Conditions de paiement : Tous les paiements de commissions sont traités via les outils automatisés de Stripe Connect. Le participant est responsable de s'assurer que ses informations de paiement fournies dans son portail affilié sont exactes. AIBA se réserve le droit de suspendre ou d'annuler toute commission issue de transactions frauduleuses, contestées ou remboursées.",
    ],
  },
  {
    title: "3. Propriété du contenu et des clones IA",
    body: [
      "Chaque utilisateur reste propriétaire des droits qu'il détient sur son contenu. AIBA fournit uniquement la plateforme permettant de créer, gérer et, si l'utilisateur le souhaite, commercialiser son clone IA, conformément aux règles de la plateforme et aux lois applicables.",
      "Chaque clone IA ou création dispose d'un identifiant unique, du nom de son créateur, de sa date de création, d'un statut (Privé, Public ou Marketplace) et des droits définis par le créateur.",
    ],
    bullets: [],
  },
  {
    title: "4. Clause de non-garantie — Contenu éducatif uniquement",
    body: [
      "AIBA fournit des contenus éducatifs et informatifs uniquement. Nous ne garantissons aucun revenu, bénéfice ou résultat financier. Les formations ont une vocation strictement éducative ; pour toute décision importante, consultez un professionnel qualifié.",
      "Les outils IA peuvent comporter des imprécisions ou des défauts et leurs résultats doivent toujours être vérifiés par l'utilisateur.",
      "Les résultats obtenus dépendent notamment des compétences, des efforts, de l'expérience de l'utilisateur et des conditions du marché.",
    ],
    bullets: [
      "Témoignages et exemples : les témoignages et exemples présentés sur la plateforme ne constituent pas une garantie de résultats futurs.",
      "Responsabilité de l'utilisateur : chaque utilisateur demeure seul responsable de ses décisions financières et de l'usage qu'il fait des contenus et outils IA.",
    ],
  },
  {
    title: "5. Clones IA et Contenu",
    body: [
      "AIBA fournit des outils de clonage IA. L'utilisateur garantit détenir les droits et consentements nécessaires sur toute donnée utilisée.",
      "Toute création de contenu déceptif, diffamatoire ou sans autorisation est strictement interdite. AIBA décline toute responsabilité sur les contenus générés par les utilisateurs et se réserve le droit de les supprimer sans préavis.",
    ],
    bullets: [],
  },
  {
    title: "6. Marketplace et Formation",
    body: [
      "La plateforme AIBA agit en tant qu'hébergeur pour la vente de produits numériques et formations. La responsabilité de la conformité, de la qualité et des droits d'auteur des produits mis en vente incombe exclusivement au vendeur (l'utilisateur).",
      "AIBA ne garantit aucun résultat financier suite à l'utilisation des outils ou des formations proposées.",
    ],
    bullets: [],
  },
  {
    title: "7. Paiements (Stripe) et Transactions",
    body: [
      "Les transactions financières sur AIBA sont facilitées par Stripe. En utilisant la plateforme, l'utilisateur accepte les conditions de services de Stripe.",
      "AIBA n'est pas responsable des erreurs de paiement, des litiges financiers entre acheteurs et vendeurs, ou des changements de politique tarifaire de Stripe. L'utilisateur est seul responsable de ses obligations fiscales liées aux revenus générés sur la plateforme.",
    ],
    bullets: [],
  },
  {
    title: "8. Communauté et Comportement",
    body: [
      "L'espace communautaire doit demeurer un environnement professionnel et respectueux. Tout harcèlement, spam, promotion illégale ou comportement nuisible entraînera la suspension immédiate du compte.",
      "AIBA se réserve le droit de modérer, sans justification, toute interaction au sein de la communauté pour préserver l'intégrité de la plateforme.",
    ],
    bullets: [],
  },
  {
    title: "9. Outils IA et Disponibilité",
    body: [
      "Les outils IA d'AIBA sont fournis « en l'état ». AIBA ne garantit pas une disponibilité ininterrompue ni une performance sans erreur des modèles d'IA utilisés.",
      "Nous nous réservons le droit de modifier, suspendre ou supprimer tout outil IA de la plateforme à tout moment sans responsabilité envers l'utilisateur.",
    ],
    bullets: [],
  },
];

export default function Legal() {
  return (
    <div className="relative min-h-screen bg-[#0F172A]" data-testid="legal-page">
      <div className="lab-fixed-bg" aria-hidden="true" />
      <div className="relative z-10 mx-auto max-w-3xl px-6 py-20 lg:px-10">
        <div className="mb-12 flex items-center justify-between">
          <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-blue-200 transition-colors hover:text-white">
            <ArrowLeft size={14} /> Retour
          </Link>
          <div className="flex items-center gap-2">
            <AibaLogo size={26} />
            <span className="font-display text-lg font-800 tracking-tighter text-white">AIBA</span>
          </div>
        </div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.35em] text-blue-400">
            <ScrollText size={14} /> [ Légal ]
          </span>
          <h1 className="mt-4 font-display text-4xl font-800 tracking-tighter text-white sm:text-5xl">
            Conditions générales & Mentions légales
          </h1>
          <p className="mt-4 font-body text-sm leading-relaxed text-[#8AA0C0]">
            Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}
          </p>
        </motion.div>

        <div className="mt-14 space-y-12">
          {SECTIONS.map((s, i) => (
            <motion.section
              key={s.title}
              data-testid={`legal-section-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="rounded-2xl border border-blue-500/15 bg-blue-400/[0.02] p-7 backdrop-blur-xl"
            >
              <h2 className="font-display text-xl font-700 tracking-tight text-white">{s.title}</h2>
              <div className="mt-4 space-y-3">
                {s.body.map((p, j) => (
                  <p key={j} className="font-body text-sm leading-relaxed text-[#CBD5E1]">{p}</p>
                ))}
              </div>
              {s.bullets.length > 0 && (
                <ul className="mt-4 space-y-3">
                  {s.bullets.map((b, j) => (
                    <li key={j} className="flex gap-3 font-body text-sm leading-relaxed text-[#CBD5E1]">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-blue-400" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              )}
            </motion.section>
          ))}
        </div>

        <p className="mt-14 border-t border-blue-500/10 pt-8 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-[#405060]">
          © {new Date().getFullYear()} AIBA · Paiements propulsés par Stripe Connect
        </p>
      </div>
    </div>
  );
}
